<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G2AAZD/tc-custom/9780226689005.jpg?1722581150276" alt="This image is the cover for the book Reconstruction Amendments"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Reconstruction Amendments
      </h1>
      <p class="bookDescription body article font2">
        <p>Ratified in the years immediately following the American Civil War, the Thirteenth, Fourteenth, and Fifteenth Amendments to the United States Constitution—together known as the Reconstruction Amendments—abolished slavery, safeguarded a set of basic national liberties, and expanded the right to vote, respectively. This two-volume work presents the key speeches, debates, and public dialogues that surrounded the adoption of the three amendments, allowing us to more fully experience how they reshaped the nature of American life and freedom.<br/><br/>             <i>Volume I</i> outlines a broad historical context for the Reconstruction Amendments along with materials related to the Thirteenth Amendment, which abolished slavery, while <i>Volume II</i> covers the Fourteenth and Fifteenth Amendments on the rights of citizenship and enfranchisement. The documents in this collection encompass a sweeping range of primary sources, from congressional talks to court cases, public speeches to newspaper articles. As a whole, the volumes meticulously depict a significant period of legal change even as they illuminate the ways in which people across the land grappled with the process of constitutional reconstruction. Filling a major gap in the literature on the era, <i>The Reconstruction Amendments</i> will be indispensable for readers in politics, history, and law, as well as anyone seeking a better understanding of the post–Civil War basis of American constitutional democracy.<br/>  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kurt T. Lash
      </h2>
      
      <p class="authorDescription body article"><B>Kurt T. Lash</B> is the E. Claiborne Robins Distinguished Chair in Law at the University of Richmond. He is the author or coauthor of several books, including, most recently, <I>The Fourteenth Amendment and the Privileges and Immunities of American Citizenship</I>.<br> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6e0ea22c